import activeTemplate from 'active_template';

// Webpack resolves `active_template` to exactly one template module for the active skin.
// This keeps non-active template CSS/assets out of the unified bundle.
export const resolveTemplate = () => activeTemplate;
